export enum CommodityQueryField {
  // ---------- COMMODITY INFO ----------
  id = 'id',
  externalId = 'externalId',
  description = 'description',

  // ---------- SUPPLIER ----------
  supplierId = 'supplierId',
  supplierExternalId = 'supplierExternalId',

  // ---------- PERFORMANCE ----------
  deliveryOnTimePercentage = 'deliveryOnTimePercentage',
  correctOrderPercentage = 'correctOrderPercentage',
  deviatingPricePercentage = 'deviatingPricePercentage',
  deviatingQuantityPercentage = 'deviatingQuantityPercentage',
  deviatingPriceQuantityPercentage = 'deviatingPriceQuantityPercentage',
  leadTime = 'leadTime',

  // ---------- ORDERS ----------
  orderVolume = 'orderVolume',
  orderVolumeYear = 'orderVolumeYear',
  orderCount = 'orderCount',
  orderCountYear = 'orderCountYear',

  // ---------- COMMODITY GROUP ----------
  primaryCommodityGroupId = 'primaryCommodityGroupId',
  commodityGroup = 'commodityGroup',

  // ---------- SOURCE SYSTEM ----------
  sourceSystemName = 'sourceSystemName',
}

export enum CommodityQueryFieldGroup {
  commodity = 'commodity',
  contract = 'contract',
  supplier = 'supplier',
  performance = 'performance',
  product = 'product',
  service = 'service',
  order = 'order',
  location = 'location',
  sourceSystem = 'sourceSystem',
  commodityGroup = 'commodityGroup',
}
